<template>
  <v-card>
    <v-card-title>
      <router-link
        :to="{
          name: 'training_form',
          params: { user_id: userId },
        }"
      >
        <v-btn fab class="mt-n4" :color="color"  v-if="can_edit()">
          <v-icon color="white">mdi-plus</v-icon>
        </v-btn>
      </router-link>

      <p class="pl-6">{{ $tc("training.title", 2) }}</p>
      <v-spacer></v-spacer>
      <v-text-field
        v-model="search"
        append-icon="mdi-magnify"
        :label="$t('common.search')"
        single-line
        hide-details
      ></v-text-field>
    </v-card-title>
    <v-data-table
      :headers="headers"
      :items="trainings"
      :loading="loading"
      item-key="id"
      class="elevation-1"
      :footer-props="footer"
      :loading-text="$t('common.loading')"
      :no-results-text="$t('common.no_results')"
      :options.sync="options"
      :server-items-length="$store.state.training.totalCount"
      dense
      show-expand
    >
      <template v-slot:expanded-item="{ headers, item }">
        <td class="pt-5 pb-5" :colspan="headers.length">
          <b>{{ $tc("common.comment", 1) }}</b
          >: {{ item.comment }}
        </td>
      </template>
      <template v-slot:no-data>
        {{ $t("common.no_results") }}
      </template>
      <template #item.type="{ item }">
        {{ $t("training.types." + item.type) }}
      </template>
      <template #item.status="{ item }">
        {{ $t("training.status." + item.status) }}
      </template>
      <template #item.comment="{ item }">
        {{ item.comment | truncate(10) }}
      </template>

      <template #item.actions="{ item }">
        <EditDelete
          @delete="remove('training', item)"
          :edit-path="{
            name: 'training_form_edit',
            params: { training_id: item.id, user_id: userId },
          }"
        />
      </template>
    </v-data-table>
  </v-card>
</template>

<script>
import { createNamespacedHelpers } from "vuex"

import { FETCH } from "@/store/action-types"
import TableMixin from "@/mixins/TableMixin"
import EditDelete from "@/components/form/EditDelete"

const { mapActions } = createNamespacedHelpers("training")

export default {
  name: "TrainingsTable",
  components: { EditDelete },
  mixins: [TableMixin],
  computed: {
    trainings() {
      return this.$store.state.training.data
    },

    headers() {
      let result = [
        {
          value: "type",
          text: this.$tc("training.types.title", 1),
          width: "33%",
        },
        {
          value: "status",
          text: this.$t("training.status.title"),
          width: "32%",
        },
        {
          value: "comment",
          text: this.$tc("common.comment", 1),
          width: "33%",
        },
        ]
      if(this.can_edit()) {
        result.push({
          value: "actions",
          align: "right",
          width: "1%",
        })
      }

      return result
    },
  },
  watch: {
    "$route.params.user_id"() {
      // call the method which loads your initial state
      console.log("REFRESH")
      this.user_id_local = this.$route.params.user_id
      this.getDataFromApi()
    },
  },
  methods: {
    ...mapActions([FETCH]),
    can_edit() {
      return this.$store.state.user.item.can_edit
    }
  },
}
</script>
